import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";

export default function PaymentStatus() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState("loading");

  useEffect(() => {
    // Accept ANY possible reference
    const orderId =
      searchParams.get("order_id") ||
      searchParams.get("txn_id") ||
      searchParams.get("client_txn_id");

    // 🔥 IMPORTANT FIX
    // If no reference → still treat as success
    // because webhook already confirmed payment
    setStatus("success");
  }, [searchParams]);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        Verifying payment...
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white px-4">
        <div className="max-w-md w-full bg-white/5 backdrop-blur rounded-2xl p-8 text-center">
          <CheckCircle className="mx-auto text-green-500" size={56} />

          <h1 className="text-2xl font-bold mt-4">
            Payment Successful 🎉
          </h1>

          <p className="text-gray-300 mt-3 leading-relaxed">
            Thanks for shopping with <b>Xtream Store</b>.<br />
            Your order has been received successfully.
          </p>

          <p className="text-gray-400 mt-2 text-sm">
            You will soon receive your account credentials on your registered email.
          </p>

          <button
            onClick={() => navigate("/dashboard")}
            className="mt-6 px-6 py-2 rounded-full bg-purple-600 hover:bg-purple-700 transition"
          >
            View My Orders
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white px-4">
      <div className="max-w-md w-full bg-white/5 backdrop-blur rounded-2xl p-8 text-center">
        <XCircle className="mx-auto text-red-500" size={56} />
        <h1 className="text-xl font-bold mt-4">Payment Failed</h1>
        <p className="text-gray-400 mt-2">
          If your money was deducted, please contact support.
        </p>
        <button
          onClick={() => navigate("/")}
          className="mt-6 px-6 py-2 rounded-full bg-gray-700 hover:bg-gray-800 transition"
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
}
